/*
 * Action Types
 */

export enum TurnstilesTypes {
  LIST_TURNSTILES_REQUEST = '@turnstiles/LIST_TURNSTILES_REQUEST',
  LIST_TURNSTILES_SUCCESS = '@turnstiles/LIST_TURNSTILES_SUCCESS',
  LIST_TURNSTILES_FAILURE = '@turnstiles/LIST_TURNSTILES_FAILURE',
}

export interface TurnstilesInteface {
  usedDate: string;
  controlResult: number;
  entryResult: number;
  gpsResult: number;
  finalResult: boolean;
}

export interface TurnstilesState {
  readonly turnstilesList: TurnstilesInteface[];
  readonly loading: boolean;
  readonly error: boolean;
}
